import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';

@Component({
  selector: 'app-informaciones',
  templateUrl: './informaciones.component.html',
  styleUrls: ['./informaciones.component.css']
})
export class InformacionesComponent implements OnInit {
  // 2
  public actual: string = '';
  informaciones = [
    {
      namekey: 'PH122Parada',
      lat: -33.5119369,
      lng: -70.6574203,
      zoom: 15
    },
    {
      namekey: 'PH221Octava',
      lat: -33.5113672,
      lng: -70.6578002,
      zoom: 15
    },
    {
      namekey: 'ciudaddelnino',
      lat: -33.5097553,
      lng: -70.6567159,
      zoom: 15
    },
    {
      namekey: 'PH799',
      lat: -33.5135012,
      lng: -70.6582689,
      zoom: 15
    },
    ];


    
  selected: any = {
    namekey: 'espacioUrbano',
    lat: -33.5097542,
    lng: -70.6567387,
    zoom: 15
  };

  constructor(private totemService: TotemService) {
    // 3
    this.actual = this.totemService.actualLanguage;
   }

  ngOnInit() {
    // this.obtenerInformaciones();
  }

  showPlace(place: any) {

    this.selected = this.informaciones[place];
    console.log('el selected', this.selected);
  }

  async obtenerInformaciones() {
    try {
      await this.totemService.getPuntos().toPromise().then((res: any) => {
        this.informaciones = res;
        // Para seleccionar solo transportes
        // this.informaciones = res.filter((punto) => punto.category === 'transporte');
        console.log('info', this.informaciones);
      });
    } catch (err) {
      console.log(err);
    }
  }
  // 4
  changeLanguage(language: any) {
    this.actual = language;
    this.totemService.changeLanguage(language);
  }
  getTranslation(key: string) {
    const word = this.totemService.getTranslation(key);
    if (word){
      return word[0].texto_descripcion;
    }
  }

}
